<template>
    <div class="referral">
        <img src="@/assets/banners/market-cards-banner.svg" style="width: 100%; height: 700px;" />
        <div style="width: 100%; height: 0; display: flex; flex-direction: row-reverse; justify-content: space-around;">
            <AbanButton class="button" :color="'success-all'" :type="'link'" :to="{name: 'Sign Up', params: {selectedMethod: 'phone-number'}}" :size="'small'">
                <b class="label">Sign Up Now</b>
                <img class="arrow-right-icon" alt="" src="@/assets/icons/arrow.svg" />
            </AbanButton>
        </div>
    </div>
</template>

<script>
import AbanButton from '../../buttons/AbanButton.vue';

export default {
    name: "ReferralBanner",
    components: {
        AbanButton
    }
}
</script>

<style scoped>
.b {
    position: relative;
    line-height: 5.446rem;
}

.aed {
    position: relative;
    font-size: 2.971rem;
    line-height: 5.446rem;
    font-weight: 600;
}

.parent {
    position: absolute;
    top: 1.5rem;
    left: -1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 0.987rem;
    opacity: 0.2;
}

.illustration {
    position: absolute;
    top: 0rem;
    left: calc(50% - 106px);
    width: 13.188rem;
    height: 15.375rem;
}

.refer-and-earn {
    font-weight: 500;
    display: flex;
    text-align: center;
    line-height: 3.198rem;
    display: inline-block;
    width: 19.625rem;
    font-size: 2.5rem;
}

.span {
    font-size: 2.619rem;
}

.b1 {
    font-size: 2.75rem;
}

ul {
    list-style-type: disc;
    /* Or 'circle', 'square', etc. */
    padding-left: 20px;
    /* Add padding to position the dot correctly */
}

.illustration-parent {
    position: absolute;
    top: 6.14rem;
    left: calc(50% - 157px);
    width: 19.625rem;
    height: 22.938rem;
    text-align: center;
    font-size: 4.456rem;
}

.share-your-referral-code-with {
    margin: 0;
    font-size: inherit;
    padding-left: 1.312rem;
}

.share-your-referral-container {
    width: 18.875rem;
    position: relative;
    line-height: 1.125rem;
    font-weight: 500;
    display: inline-block;
}

.share-your-referral-code-with-parent {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 20rem;
    gap: 0.5rem;
}

.referral-inner {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    margin-top: 1.5rem;
}

.label {
    position: relative;
    line-height: 1.25rem;
}

.arrow-right-icon {
    width: 1.5rem;
    position: relative;
    height: 1.5rem;
    overflow: hidden;
    flex-shrink: 0;
}

.button {
    box-shadow: 0px 2px 5.2px rgba(41, 92, 167, 0.24);
    border-radius: 8px;
    background-color: #0fa964 !important;
    width: 75%;
    height: 3.5rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0.875rem 1.25rem;
    box-sizing: border-box;
    gap: 0.75rem;
    position: relative;
    top: -115px;
}

.referral {
    width: 100%;
    max-height: 48rem;
    overflow: hidden;
    text-align: left;
    font-size: 1rem;
    color: #fff;
    background-color: rgba(17, 39, 121, 1);
}
</style>